import React from 'react';
import logo from "./assets/images/mars-snacking.png";
import threeDlogo from "./assets/images/3dDCOMLogo.webp";
import './App.css';
import AIKnowledgeBase from './components/AIKnowledgeBaseFinal';

function App() {

  return (
    <div className='main-container'>
      <div className='w-full'>
        <div className='header-section w-full py-[20px] px-[23px] text-[16px] font-MarsCentraBook bg-[#121212]'>
          <div className='flex items-center justify-between gap-[8px]'>
            <div className='flex items-center'>
              <img src={logo} className="w-[70px] h-full"></img>
              <p className='flex items-center'>
                <span className='inline-block h-[43px] text-[#747474] border border-1 border-[#747474] mx-[8px]'></span> 
                <span className='title-heading text-[24px] text-[#FFF] mr-[3px]'>AI Learning Mind Map</span>
              </p>
            </div>
            <img src={threeDlogo} className="w-[70px] h-full"></img>
            
          </div>
        </div>
        <div className='border-solid border-b-[1px] border-[#616161]'></div>
      </div>
      
      <div className='main-body h-[82%]'>
        <AIKnowledgeBase/>
      </div>
      
    </div>
  )
}

export default App
